module.exports = __webpack_public_path__ + "static/developers-06b13f682dc478862f4adfcd65abf752.png";